"use client";

import { useRef } from "react";
import { Link } from "react-router-dom"
import { Card, CardContent } from "../ui/card";
import { ChevronLeft, ChevronRight } from "lucide-react";
import GeneralMedicine from "../images/General Medicine.jpg"
import Cardiology from "../images/Cardiology.jpg"
import Brain from "../images/brain.jpg"
import Orthopaedics from "../images/Orthopaedics (1).jpg"
import Pediatrics from "../images/Pediatrics.jpg"
import Obstetrics from "../images/Obstetrics & Gynaecology (2).jpg"
import EmergencyCare from "../images/Emergency Care.jpg"
import Surgery from "../images/Surgery.jpg"





export default function ServicesSection() {
  // plain ref – no generic
  const scrollRef = useRef(null);

  const services = [
    {
      name: "General Medicine",
      description:
        "Comprehensive care for adults with a focus on preventive medicine and chronic disease management.",
      image: GeneralMedicine
      // icon: "🩺",-
    },
    {
      name: "Cardiology",
      description:
        "Expert care for heart conditions with advanced diagnostics and personalized treatment plans.",
      image: Cardiology
      // icon: "❤️",
    },
    {
      name: "Neurology",
      description:
        "Specialized care for conditions affecting the brain, spine, and nervous system.",
      image: Brain
      // icon: "🧠",
    },
    {
      name: "Orthopedics",
      description:
        "Expert care for bones, joints, ligaments, tendons, and muscles with advanced surgical techniques.",
      image: Orthopaedics
      // icon: "🦴",
    },
    {
      name: "Pediatrics",
      description:
        "Specialized healthcare for infants, children, and adolescents with compassionate care.",
      image: Pediatrics
      // icon: "👶",
    },
    {
      name: "Gynecology",
      description:
        "Complete women's health care from adolescence to post‑menopause with expert specialists.",
      image: Obstetrics
      // icon: "👩‍⚕️",
    },
    {
      name: "Emergency Care",
      description:
        "24/7 critical care for accidents, injuries, and medical emergencies with rapid response.",
      image: EmergencyCare
      // icon: "🚨",
    },
    {
      name: "Surgery",
      description:
        "Advanced surgical procedures with minimally invasive techniques and expert surgical teams.",
      image: Surgery
      // icon: "🔬",
    },
  ];

  // scroll handler — no explicit types
  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 320;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="py-8 md:py-16 bg-white">
      <div className="container mx-auto px-4">
        {/* Heading */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-semibold text-apple-gray-500 mb-2">
            Our Medical Services
          </h2>
          <p className="text-apple-gray-400 max-w-2xl mx-auto">
            MAMS Hospital offers comprehensive care across multiple
            specialties, ensuring all your healthcare needs are met under one
            roof.
          </p>
        </div>

        {/* Carousel */}
        <div className="relative">
          {/* scroll buttons */}
          <button
            onClick={() => scroll("left")}
            className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg rounded-full p-2 hover:bg-apple-gray-50 transition-colors"
            aria-label="Scroll left"
          >
            <ChevronLeft className="h-6 w-6 text-apple-gray-400" />
          </button>

          <button
            onClick={() => scroll("right")}
            className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg rounded-full p-2 hover:bg-apple-gray-50 transition-colors"
            aria-label="Scroll right"
          >
            <ChevronRight className="h-6 w-6 text-apple-gray-400" />
          </button>

          {/* scrollable cards */}
          <div
            ref={scrollRef}
            className="flex gap-6 overflow-x-auto scrollbar-hide pb-4 px-3 md:px-12"
            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
          >
            {services.map((service, index) => (
              <Card
                key={index}
                className="flex-shrink-0 w-80 border-apple-gray-100 hover:border-apple-teal transition-all duration-300 hover:shadow-lg rounded-3xl overflow-hidden"
              >
                <div className="aspect-[4/3] relative overflow-hidden">
                  <img
                    src={service.image || "/placeholder.svg"}
                    alt={service.name}
                    className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                  />
                  <div className="absolute top-4 left-4  backdrop-blur-sm rounded-full p-2">
                    <span className="text-2xl">{service.icon}</span>
                  </div>
                </div>

                <CardContent className="p-6">
                  <h3 className="text-xl font-semibold text-apple-gray-500 mb-3">
                    {service.name}
                  </h3>
                  <p className="text-apple-gray-400 mb-4">
                    {service.description}
                  </p>
                  {/* <Link
                    to={`/departments/${service.name
                      .toLowerCase()
                      .replace(/\s+/g, "-")}`}
                  >
                    <div className="text-apple-teal font-medium hover:underline">
                      Learn More →
                    </div>
                  </Link> */}
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        {/* view‑all link */}
        <div className="text-center mt-10">
          <Link to="/departments">
            <div className="apple-button-secondary">View All Services</div>
          </Link>
        </div>
      </div>
    </section>
  );
}
